import { inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ErrorResponseDetail } from '@ddv/http';
import { BehaviorSubject, filter, Observable } from 'rxjs';

export interface InitializationError {
    message: string;
    error: ErrorResponseDetail;
}

@Injectable({ providedIn: 'root' })
export class InitializationErrorCollectorService {
    public errors$: Observable<InitializationError[]>;

    private readonly router = inject(Router);
    private errors: InitializationError[] = [];
    private readonly errorsSubject = new BehaviorSubject<InitializationError[]>([]);

    constructor() {
        this.errors$ = this.errorsSubject.asObservable();

        this.router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe(() => {
                this.errors = [];
                this.errorsSubject.next(this.errors);
            });
    }

    addError(message: string, error: unknown): void {
        console.error('An error occurred during route resolution:', message, error);
        if (!(error instanceof ErrorResponseDetail)) {
            console.error('cannot handle non ErrorResponseDetail errors', error);
        } else {
            this.errors.push({ message, error });
            this.errorsSubject.next(this.errors);
        }
    }
}
